export const transparencia_item = [
    {
        "transparencia_item_nombre" : "48 Rubros",
        "transparencia_item_url" : "Rubros"
    },
    {
        "transparencia_item_nombre" : "Ley de Disciplina Financiera",
        "transparencia_item_url" : "LeyDisciplinaFinanciera"
    },
    {
        "transparencia_item_nombre" : "Armonización Contable",
        "transparencia_item_url" : "ArmonizacionContable"
    },
    {
        "transparencia_item_nombre" : "Licitaciones Públicas",
        "transparencia_item_url" : "LicitacionesPublicas"
    },
    {
        "transparencia_item_nombre" : "Informes de Gestión Financiera Consolidada",
        "transparencia_item_url" : "InformesGestionFinanciera"
    },
    {
        "transparencia_item_nombre" : "Avisos de Privacidad",
        "transparencia_item_url" : "AvisosPrivacidad"
    },
    {
        "transparencia_item_nombre" : "Explicación de la Información Financiera Publicada",
        "transparencia_item_url" : "InformacionFinancieraPublicada"
    }
]